import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptionsArgs } from "@angular/http";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";

@Injectable()
export class ClassScheduleService {
  //  private _apiRootUrl: string = 'http://localhost:51872/api/locations';
  private _apiRootUrl: string = `${environment.apiRootURL}/locations`;

  constructor(private _http: Http) {}

  getLocations(classId: string, studentId: string, distanceType: string) {
    console.log("HTTP GET Class Schedules");
    const url = `${this._apiRootUrl}/display/class/${classId}/student/${studentId}/distance/${distanceType}`;
    return this._http.get(url).map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/class-schedule.service.ts